import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { FormattingService } from '../../../services/formatting.service';
import { IObject } from '../../../../../type_definitions/datatypes';
import { CompanyDataService } from '../../../company/company-data.service';
import { Override } from '../../../app-decorators';
import { GaEventService } from '../../../services/ga-event.service';

@Component({
  selector: 'add-oem-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class AddOemActionComponent extends BaseReportActionsDialog implements OnInit {
  private vendorField: IExtraFieldConfigurationObject;

  constructor(
    private formlyService: GaFormlyService,
    private formattingService: FormattingService,
    private companyDataService: CompanyDataService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // create fields
    this.fields = this.createFields();
    this.fillFields();
  }

  @Override(BaseReportActionsDialog)
  public getModel(): IObject {
    // return only the vendor id of the selected option instead of whole object
    return {
      vendorId: this.model.vendor?.id
    };
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    this.vendorField = this.formlyService.aSearch('vendor', 'Vendor')
      .isRequired()
      .withFormat(this.formattingService.formatName)
      .withExtraOptions({
        templateOptions: {
          minSearchLength: 1,
          localSearch: true
        }
      })
      .build();

    return [ this.vendorField ];
  }

  private fillFields(): void {
    this.formlyService.fillField(this.vendorField, this.companyDataService.listVendors());
  }
}